module.exports = __webpack_public_path__ + "static/media/taste-of-cup.284a3736.jpg";